/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createLesson = /* GraphQL */ `
  mutation CreateLesson(
    $input: CreateLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    createLesson(input: $input, condition: $condition) {
      id
      title
      description
      content
      order
      duration
      survey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLesson = /* GraphQL */ `
  mutation UpdateLesson(
    $input: UpdateLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    updateLesson(input: $input, condition: $condition) {
      id
      title
      description
      content
      order
      duration
      survey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLesson = /* GraphQL */ `
  mutation DeleteLesson(
    $input: DeleteLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    deleteLesson(input: $input, condition: $condition) {
      id
      title
      description
      content
      order
      duration
      survey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserLesson = /* GraphQL */ `
  mutation CreateUserLesson(
    $input: CreateUserLessonInput!
    $condition: ModelUserLessonConditionInput
  ) {
    createUserLesson(input: $input, condition: $condition) {
      id
      userID
      lessonID
      progress
      startedAt
      finishedAt
      firstName
      lastName
      email
      dateOfBirth
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserLesson = /* GraphQL */ `
  mutation UpdateUserLesson(
    $input: UpdateUserLessonInput!
    $condition: ModelUserLessonConditionInput
  ) {
    updateUserLesson(input: $input, condition: $condition) {
      id
      userID
      lessonID
      progress
      startedAt
      finishedAt
      firstName
      lastName
      email
      dateOfBirth
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserLesson = /* GraphQL */ `
  mutation DeleteUserLesson(
    $input: DeleteUserLessonInput!
    $condition: ModelUserLessonConditionInput
  ) {
    deleteUserLesson(input: $input, condition: $condition) {
      id
      userID
      lessonID
      progress
      startedAt
      finishedAt
      firstName
      lastName
      email
      dateOfBirth
      createdAt
      updatedAt
      __typename
    }
  }
`;
